import classNames from 'classnames/bind';
import emImg from '../../assets/images/Emty.png';
import style from './Empty.module.css';
const cx = classNames.bind(style);
function Empty ({classNames, title}) {
    return (
        <div className={cx('container', classNames)} >
            <img src={emImg} alt='empty'/>
            <p>{title || 'Không có dữ liệu'}</p>
        </div>
    )
}

export default Empty;